import { FC, useEffect, useState } from "react";

import { LogoColorfull, MaintenanceIcon } from "../../assets";

export const MaintenancePage: FC = () => {

  const [currentDateTime, setCurrentDateTime] = useState<string>("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setCurrentDateTime(
        now.toLocaleString("es-AR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false
        })
      );
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
        padding: 24,
        boxSizing: "border-box",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 800,
          width: "100%",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
          padding: "40px 32px",
          textAlign: "center",
          borderLeft: "6px solid #ff4d4f",
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <img
            src={LogoColorfull}
            alt="BARBUSS Productores"
            style={{
              width: "35vw",
              maxWidth: 480,
              height: "auto",
              objectFit: "contain",
            }}
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <img
            src={MaintenanceIcon}
            alt="Mantenimiento"
            style={{
              width: "35vw",
              maxWidth: 480,
              height: "auto",
              objectFit: "contain",
            }}
          />
        </div>

        <h1
          style={{
            fontSize: 22,
            color: "#262626",
            marginBottom: 12,
          }}
        >
          NOS ENCONTRAMOS EN MANTENIMIENTO
        </h1>

        <p
          style={{
            fontSize: 16,
            color: "#595959",
            lineHeight: 1.5,
          }}
        >
          Estamos realizando tareas de mantenimiento programado. Pronto estaremos disponibles nuevamente. 
        </p>

        <p
          style={{
            marginTop: 20,
            fontSize: 14,
            color: "#8c8c8c",
          }}
        >
          Disculpa las molestias y gracias por tu paciencia.
        </p>

        {/* Fecha y hora */}
        <p
          style={{
            marginTop: 30,
            fontSize: 12,
            color: "#bfbfbf",
          }}
        >
          {currentDateTime}
        </p>

      </div>
    </div>
  );
};

export default MaintenancePage;